export default __webpack_public_path__ + "static/blog-8b0ad8456ae4e055ac58e994b91e3cbf.png";